import { render, staticRenderFns } from "./Setting-Info.vue?vue&type=template&id=57d97a88&scoped=true&"
import script from "./Setting-Info.vue?vue&type=script&lang=js&"
export * from "./Setting-Info.vue?vue&type=script&lang=js&"
import style0 from "./Setting-Info.vue?vue&type=style&index=0&id=57d97a88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d97a88",
  null
  
)

export default component.exports